import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["size"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// DO NOT EDIT IT MANUALLY

import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var SvgCloudSearchService = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 24 : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  props.width = undefined;
  props.height = undefined;
  var testId = 'icon-cloud-search-service';
  var style = {};
  var isCustomSize = typeof size === 'number';
  if (isCustomSize) {
    style.width = size + 'px';
    style.height = size + 'px';
    if (!props.style) props.style = {};
    props.style.width = size + 'px';
    props.style.height = size + 'px';
  }
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    "data-test-id": testId,
    ref: ref
  }, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      fill: "inherit",
      fillRule: "evenodd",
      d: "M10.857 3.28C8.688 3.433 6.6 4.51 5.174 6.211a8.23 8.23 0 0 0 .002 10.578c1.46 1.737 3.441 2.752 5.733 2.939 1.983.161 4.136-.498 5.691-1.743l.18-.144 1.84 1.84 1.841 1.839.529-.53.53-.531-1.839-1.838-1.838-1.838.098-.121c.053-.067.221-.302.372-.522a8.22 8.22 0 0 0-.489-9.929c-1.307-1.554-3.145-2.586-5.105-2.865a10 10 0 0 0-1.862-.066m1.531 1.541a6.73 6.73 0 0 1 5.791 5.791 6.74 6.74 0 0 1-4.374 7.226 6.8 6.8 0 0 1-4.61 0c-2.374-.875-4.052-2.966-4.374-5.45a6.68 6.68 0 0 1 1.917-5.65 6.68 6.68 0 0 1 5.65-1.917M11.14 7.279c-.624.078-1.102.319-1.581.8-.347.348-.536.641-.674 1.048-.063.184-.087.211-.229.253-.581.171-1.298.77-1.588 1.328-.531 1.02-.376 2.286.381 3.113.445.484.901.748 1.52.875.457.095 4.605.095 5.062 0 .617-.127 1.077-.391 1.514-.87.763-.835.92-2.096.387-3.118-.29-.558-1.007-1.157-1.588-1.328-.142-.042-.166-.069-.229-.253-.213-.628-.75-1.253-1.335-1.555a2.83 2.83 0 0 0-1.64-.293m.889 1.595c.539.277.731.673.731 1.51v.368l.55.015c.474.013.573.027.719.104q.579.306.687.899c.045.253.001.602-.102.802a1.5 1.5 0 0 1-.551.541l-.203.107H9.14l-.203-.107a1.5 1.5 0 0 1-.551-.541c-.103-.2-.147-.549-.102-.802q.108-.593.687-.899c.145-.076.245-.091.714-.104l.545-.014.021-.507c.012-.278.043-.573.067-.655.093-.307.486-.688.817-.79.212-.065.703-.026.894.073"
    })
  }));
});
export default SvgCloudSearchService;